var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInvoice = function SvgInvoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M3.947 0A2.38 2.38 0 0 0 1.58 2.368v12.369h-.79a.79.79 0 0 0-.789.79v1.052A3.424 3.424 0 0 0 3.421 20H15a3.424 3.424 0 0 0 3.421-3.421V2.369A2.383 2.383 0 0 0 16.053 0zm0 1.579h12.106c.492 0 .79.297.79.79v14.21c0 1.06-.783 1.842-1.843 1.842s-1.842-.782-1.842-1.842v-1.053a.79.79 0 0 0-.79-.79h-9.21V2.369c0-.492.297-.789.79-.789M1.58 16.316h10v.263c0 .694.259 1.302.615 1.842H3.42c-1.06 0-1.842-.782-1.842-1.842z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M5.263 4.912c0-.387.314-.701.702-.701h7.895a.702.702 0 1 1 0 1.403H5.965a.7.7 0 0 1-.702-.702M7.544 8.246c0-.388.314-.702.702-.702h5.614a.702.702 0 1 1 0 1.403H8.246a.7.7 0 0 1-.702-.701"
  })));
};
export default SvgInvoice;